module.exports = __webpack_public_path__ + "media/images/emblems/GamsSG-ef8f357d3049e50858b3dc74239acb6e.png";